import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { CMSContainer } from "../../../components/ui/CMSContainer";
import { cmsService } from "../services/cms.service";
import { CMS_PAGE_MAP } from "../../../models/constants/cmsPageMap";
import localization from "../../../config/localization";
import { Button } from "../../../components/ui";
import { SupportedLanguages } from "../../../models/constants/supportedLanguages";
import errorModal from "../../../services/errorModal.service";
import { useLanguage } from "../../../config/localization/LanguageProvider";

export default function CMSPage() {
  const { pageKey } = useParams<{ pageKey: string }>();

  const [html, setHtml] = useState("");
  const [pageTitle, setPageTitle] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [invalidPage, setInvalidPage] = useState(false);

  const { language: languageCode } = useLanguage();

  useEffect(() => {
    if (!pageKey || !CMS_PAGE_MAP[pageKey]) {
      setInvalidPage(true);
      return;
    }
    const config = CMS_PAGE_MAP[pageKey];
    setPageTitle(localization.getString(config.titleKey));
    loadCMS(config.pageName);
  }, [pageKey, languageCode]);

  const loadCMS = async (pageName: string) => {
    setLoading(true);
    try {
      const res = await cmsService.getCmsContentByPageName(pageName);

      if (res.isSuccess && res.data?.details?.length) {
        const content = res.data.details[0];

        setHtml(
          languageCode === SupportedLanguages.Hindi ? content.contentHindi : content.contentEnglish
        );
      }
      else {
        errorModal.showErrorModal(res.statusCode, res.message);
      }
    } catch (err) {
      console.error("CMS load failed", err);
    } finally {
      setLoading(false);
    }
  };

  if (invalidPage) return <Navigate to="/404" replace />;
  if (loading) return <p>Loading...</p>;

  return (
    <div className="footer-pg text-justify px-4 pt-3">
      {pageTitle && (
        <h1>
          <Button onClick={() => window.history.back()} className="">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </Button>
          {pageTitle}
        </h1>
      )}

      <CMSContainer html={html} />
    </div>
  );
}
